import React, { useEffect } from 'react';

import { Form, Radio } from 'antd';
import styled from 'styled-components';

import { useCMASummaryContractsFilterContext } from './CMASummaryContractsFilterContext';
import { COMMUNITY_CONTRACT_SELECTION_TYPE, CONTRACT_DISPLAY_TYPES } from '../../../../constants';
import RectangularSelect from '../components/RectangularSelect';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
  padding: 20px;
  border-bottom: solid 1px var(--line-gray);
`;

const Title = styled.span`
  font-family: var(--font-bold);
`;

const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-flow: column;
  gap: 10px;
`;

const RadioContent = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  height: 36px;
`;

type ContractSelectionTypeSelectProps = { disabled?: boolean };

const ContractSelectionTypeSelect = ({ disabled = false }: ContractSelectionTypeSelectProps) => (
  <Form.Item name="contractSelectionType">
    <RectangularSelect
      disabled={disabled}
      style={{ width: 200, height: 36, borderRadius: 0 }}
      options={[
        {
          label: 'Approximate comparison',
          value: COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE,
        },
        {
          label: 'Exact comparison',
          value: COMMUNITY_CONTRACT_SELECTION_TYPE.EXACT,
        },
      ]}
    />
  </Form.Item>
);

type Props = {
  showEveryoneOption?: boolean;
};

const CMASummaryFilterContractDisplay = ({ showEveryoneOption = true }: Props) => {
  const { form } = useCMASummaryContractsFilterContext();
  const contractDisplayType = Form.useWatch('contractDisplayType', form) ?? form?.getFieldValue('contractDisplayType');

  useEffect(() => {
    const updates: any = {};

    if (contractDisplayType === CONTRACT_DISPLAY_TYPES.EVERYONES_CONTRACTS) {
      updates.contractSelectionType = COMMUNITY_CONTRACT_SELECTION_TYPE.EXACT;
    } else {
      updates.contractSelectionType = COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE;
    }
    updates.communityContractSlugs = [];

    form?.setFieldsValue(updates);
  }, [contractDisplayType]);

  return (
    <Container>
      <Title>CONTRACT DISPLAY</Title>
      <Form.Item name="contractDisplayType">
        <RadioGroup value={contractDisplayType}>
          <RadioContent>
            <Radio value={CONTRACT_DISPLAY_TYPES.MY_CONTRACTS}>My contracts</Radio>
            {contractDisplayType === CONTRACT_DISPLAY_TYPES.MY_CONTRACTS && <ContractSelectionTypeSelect />}
          </RadioContent>
          {showEveryoneOption && (
            <RadioContent>
              <Radio value={CONTRACT_DISPLAY_TYPES.EVERYONES_CONTRACTS}>Everyone's contracts</Radio>
              {contractDisplayType === CONTRACT_DISPLAY_TYPES.EVERYONES_CONTRACTS && (
                <ContractSelectionTypeSelect disabled />
              )}
            </RadioContent>
          )}
        </RadioGroup>
      </Form.Item>
    </Container>
  );
};

export default CMASummaryFilterContractDisplay;
